module.exports = __webpack_public_path__ + "static/media/downloaded-white.c9c51884.svg";